import React from 'react';
import { connect } from 'react-redux';
// import { useTable } from 'react-table';
import { updateAdhocInfo } from './thunks';
import AdhocCreateForm from './AdhocCreate';
// import Container from 'react-bootstrap/Container';
import Modal from 'react-bootstrap/Modal';
// import Button from 'react-bootstrap/Button';
import 'bootstrap/dist/css/bootstrap.min.css';
import './AdhocCreateModal.css';

const AdhocCreateModal = ({ userInfo, adhocInfo, startUpdateAdhocInfo }) => {

  const handleClose = () => startUpdateAdhocInfo({ showCreateDialog:false });
  // const handleShow = () => startUpdateAdhocInfo({ showCreateDialog:true });

  const content = (
    <Modal size="xl" show={adhocInfo.showCreateDialog} onHide={handleClose} animation={false}>
      <Modal.Header closeButton>
        <Modal.Title>
          Adhoc Request {adhocInfo.editRecord.request_id ? "(ID: " + adhocInfo.editRecord.request_id + ")" : "" }
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <AdhocCreateForm />
      </Modal.Body>
      <Modal.Footer></Modal.Footer>
    </Modal>
  );
  return content;
};

const mapState = state => ({
  userInfo: state.userInfo,
  adhocInfo: state.adhocInfo,
});

const mapDispatch = dispatch => ({
  startUpdateAdhocInfo: (data) => dispatch(updateAdhocInfo(data)),
});

export default connect(mapState, mapDispatch)(AdhocCreateModal);
